import { Label } from "@/components/Product/Label/label";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useCashbackContext } from "../../context/cashback.context";

export const ProductLabel = () => {
    const { t } = useGranite();

    const { cashbackAmount, cashbackUnit } = useCashbackContext();

    return (
        <Label
            position={"left"}
            type={"label"}
        >
            <Label.Entry>{t("promotionLabel.cashback")}</Label.Entry>
            <Label.Entry>
                {cashbackAmount}
                {cashbackUnit}
            </Label.Entry>
        </Label>
    );
};
